module.exports = __webpack_public_path__ + "img/history.c725946c.svg";